<template>
  <div class="options pb-9">
    <i
      hidden
      class="mr-3 fa fa-question-circle text-dark"
      @click="toggleHelp()"
      v-shortkey.once="['q']"
      @shortkey="toggleHelp()"
    ></i>
    <v-dialog v-model="guide" persistent width="700">
      <v-card class="dialog-card pa-0">
        <v-card-title class="text-center">
          <h4>
            برای استفاده بهتر از این صفحه میتوانید از کلیدهای زیر استفاده کنید
          </h4>
        </v-card-title>
        <v-card-text class="pt-3"> </v-card-text>
        <v-card-subtitle>
          <v-btn
            elevation="3"
            height="45"
            color="grey darken-1"
            class="me-3"
            outlined
            small
            style="border-radius: 6px !important; font-size: 17px !important"
            >q</v-btn
          >
          <b>بستن این راهنما</b>
        </v-card-subtitle>
      </v-card>
    </v-dialog>
    <v-card class="common-card">
      <div class="d-flex flex-row">
        <h4 class="c-grey pt-2">تنظیمات باشگاه مشتریان</h4>
        <!-- <v-divider class="me-10 ms-10" vertical></v-divider>
        <div class="custom-input2">
          <v-text-field
            hide-details
            outlined
            dense
            label="جستجو..."
            prepend-icon="$Search"
            @input="currentPage = 1"
            v-model="filter"
          >
            <template v-slot:append>
              <v-icon
                v-if="filter.length"
                class="red--text text--lighten-2"
                @click="
                  filter = '';
                  currentPage = 1;
                "
                >mdi-close-circle</v-icon
              >
            </template>
          </v-text-field>
        </div> -->
      </div>
      <hr class="mt-5" />

      <v-card v-if="busy" flat>
        <div class="d-flex flex-column align-items-center mt-8 py-6">
          <atom-spinner
            :animation-duration="1000"
            :size="80"
            :color="'#EF6C00'"
          />
          <p class="primary--text font-weight-bold mt-4">
            در حال بارگذاری اطلاعات...
          </p>
        </div>
      </v-card>
      <div v-else class="custom-table mt-3">
        <h4 class="primary--text my-12">مدیریت دریافت اعتبار</h4>
        <b-table
          responsive
          show-empty
          :current-page="currentPage"
          :per-page="perPage"
          :items="creditTiers"
          :fields="optionsFields"
          empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
          empty-text="رکوردی برای نمایش وجود ندارد."
          striped
          thead-class="headClass"
          tbody-class="bodyClass"
        >
          <template v-slot:empty>
            <div
              style="text-align: center; vertical-align: middle"
              class="pt-0"
            >
              رکوردی برای نمایش وجود ندارد.
            </div>
          </template>
          <template v-slot:head()="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.label }}
            </div>
          </template>
          <template v-slot:cell(index)="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.index + 1 + perPage * (currentPage - 1) }}
            </div>
          </template>
          <template v-slot:cell()="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.value }}
            </div>
          </template>
          <template v-slot:cell(tierMinimumPrice)="data">
            <div
              style="text-align: center; vertical-align: middle; width: 200px"
              class="d-flex flex-row mx-auto"
              @click="checkDisabledField(computedFocusedField(data.item))"
            >
              <vuetify-money
                v-model.number="data.item.tierMinimumPrice"
                :valueWhenIsEmpty="whenIsEmpty"
                :options="vMoneyOptions"
                hide-details
                class="me-4"
                style="margin-top: -23px"
                type="number"
                outlined
                dense
                :disabled="
                  !computedFocusedField(data.item) || data.item.name == 'برنزی'
                "
              />
              <div style="margin-top: -3px">تومان</div>
            </div>
            <div
              class="red--text pt-3 font-weight-bold mx-auto"
              style="font-size: 12px"
              v-if="!computedValidAmount(data.value, data.index)"
            >
              <v-icon small class="red--text">mdi-alert-outline</v-icon>
              مبلغ ورودی باید بیشتر از سطح پیشین و کمتر از سطح بالاتر باشد.
            </div>
          </template>
          <template v-slot:cell(tierPercentage)="data">
            <div
              style="text-align: center; vertical-align: middle; width: 200px"
              class="d-flex flex-row mx-auto"
              @click="checkDisabledField(computedFocusedField(data.item))"
            >
              <v-text-field
                dense
                outlined
                type="number"
                min="0"
                style="width: 30px; margin-top: -14px"
                class="me-4 pt-0"
                hide-details
                :rules="[rules.validPercentage]"
                v-model.number="data.item.tierPercentage"
                @input="reactivity = !reactivity"
                :disabled="!computedFocusedField(data.item)"
              >
              </v-text-field>
              <div style="margin-top: -3px">% از مبلغ فاکتور</div>
            </div>
          </template>

          <template v-slot:cell(operation)="data">
            <div
              style="text-align: center; vertical-align: middle"
              class="pt-0"
            >
              <span v-show="false">{{ reactivity }}</span>
              <v-btn
                class="orange-mainBtn"
                width="130"
                :loading="loading[data.index]"
                :disabled="
                  data.item.name == 'برنزی'
                    ? false
                    : !options.creditTiers[data.index].tierMinimumPrice ||
                      !options.creditTiers[data.index].tierPercentage ||
                      !computedValidAmount(
                        options.creditTiers[data.index].tierMinimumPrice,
                        data.index
                      ) ||
                      !computedFocusedField(data.item)
                "
                @click="editCredit(data.item, data.index)"
                >اعمال تغییرات
                <v-icon class="ms-2" style="margin-top: -6px"
                  >$Edit</v-icon
                ></v-btn
              >
            </div>
          </template>
        </b-table>

        <br />
        <br />
        <br />

        <h4 class="primary--text my-12">مدیریت سطح‌های فروش</h4>

        <b-table
          responsive
          show-empty
          :current-page="currentPage"
          :per-page="perPage"
          :items="saleTierOptions"
          :fields="optionsFields2"
          empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
          empty-text="رکوردی برای نمایش وجود ندارد."
          striped
          thead-class="headClass"
          tbody-class="bodyClass"
        >
          <template v-slot:empty>
            <div
              style="text-align: center; vertical-align: middle"
              class="pt-0"
            >
              رکوردی برای نمایش وجود ندارد.
            </div>
          </template>
          <template v-slot:head()="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.label }}
            </div>
          </template>
          <template v-slot:cell(index)="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.index + 1 + perPage * (currentPage - 1) }}
            </div>
          </template>
          <template v-slot:cell()="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.value }}
            </div>
          </template>
          <template v-slot:cell(tierMinimumPrice)="data">
            <div
              style="text-align: center; vertical-align: middle; width: 200px"
              class="d-flex flex-row mx-auto"
              :aria-readonly="data.item.Name == 'برنزی'"
            >
              <vuetify-money
                v-model="data.item.tierMinimumPrice"
                :valueWhenIsEmpty="whenIsEmpty"
                :options="vMoneyOptions"
                hide-details
                class="me-4"
                style="margin-top: -23px"
                type="number"
                outlined
                dense
              />
              <div style="margin-top: -3px">تومان</div>
            </div>
            <div
              class="red--text pt-3 font-weight-bold mx-auto"
              style="font-size: 12px"
              v-if="!computedValidAmount(data.value, data.index)"
            >
              <v-icon small class="red--text">mdi-alert-outline</v-icon>
              مبلغ ورودی باید بیشتر از سطح پیشین و کمتر از سطح بالاتر باشد.
            </div>
          </template>
          <template v-slot:cell(salePercentage)="data">
            <div
              style="text-align: center; vertical-align: middle; width: 200px"
              class="d-flex flex-row mx-auto"
            >
              <v-text-field
                dense
                outlined
                type="number"
                min="0"
                style="width: 30px; margin-top: -14px"
                class="me-4 pt-0"
                hide-details
                :rules="[rules.validPercentage]"
                v-model="data.item.salePercentage"
              >
              </v-text-field>
              <div style="margin-top: -3px">% از مبلغ فروش</div>
            </div>
          </template>
          <template v-slot:cell(operation)="data">
            <div
              style="text-align: center; vertical-align: middle"
              class="pt-0"
            >
              <span v-show="false">{{ reactivity }}</span>
              <v-btn
                class="orange-mainBtn"
                width="130"
                :loading="loading[data.index]"
                :disabled="
                  !options.creditTiers[data.index].tierPercentage ||
                  !computedValidAmount(
                    options.creditTiers[data.index].tierMinimumPrice,
                    data.index
                  )
                "
                @click="editSaleTier(data.item, data.index)"
                >اعمال تغییرات
                <v-icon class="ms-2" style="margin-top: -6px"
                  >$Edit</v-icon
                ></v-btn
              >
            </div>
          </template>
        </b-table>

        <br />
        <br />
        <br />

        <h4 class="primary--text my-12">زمان انقضای اعتبار</h4>
        <b-table
          responsive
          show-empty
          :current-page="currentPage"
          :per-page="perPage"
          :items="creditExpiryDate"
          :fields="timesFields"
          empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
          empty-text="رکوردی برای نمایش وجود ندارد."
          striped
          thead-class="headClass"
          tbody-class="bodyClass"
        >
          <template v-slot:empty>
            <div
              style="text-align: center; vertical-align: middle"
              class="pt-0"
            >
              رکوردی برای نمایش وجود ندارد.
            </div>
          </template>
          <template v-slot:head()="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.label }}
            </div>
          </template>

          <template v-slot:cell()="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.value }}
            </div>
          </template>

          <template v-slot:cell(time)="data">
            <div
              style="text-align: center; vertical-align: middle; width: 150px"
              class="d-flex flex-row mx-auto"
            >
              <v-text-field
                dense
                outlined
                type="number"
                min="1"
                style="width: 30px; margin-top: -14px"
                class="me-4 pt-0"
                hide-details
                v-model="data.item.time"
              >
              </v-text-field>
              <div style="margin-top: -3px">ماه</div>
            </div>
          </template>

          <template v-slot:cell(operation)="data">
            <div
              style="text-align: center; vertical-align: middle"
              class="pt-0"
            >
              <v-btn
                class="orange-mainBtn"
                width="120"
                :loading="loading2"
                @click="editTime(data.item)"
                >اعمال تغییرات
                <v-icon class="ms-2" style="margin-top: -6px"
                  >$Edit</v-icon
                ></v-btn
              >
            </div>
          </template>
        </b-table>
        <br />
        <br />
        <br />

        <h4 class="primary--text my-12">بازه خرید سریع</h4>
        <b-table
          responsive
          show-empty
          :current-page="currentPage"
          :per-page="perPage"
          :items="fastBuy"
          :fields="fastFields"
          empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
          empty-text="رکوردی برای نمایش وجود ندارد."
          striped
          thead-class="headClass"
          tbody-class="bodyClass"
        >
          <template v-slot:empty>
            <div
              style="text-align: center; vertical-align: middle"
              class="pt-0"
            >
              رکوردی برای نمایش وجود ندارد.
            </div>
          </template>
          <template v-slot:head()="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.label }}
            </div>
          </template>

          <template v-slot:cell()="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.value }}
            </div>
          </template>
          <template v-slot:cell(time)="data">
            <div
              style="text-align: center; vertical-align: middle; width: 150px"
              class="d-flex flex-row mx-auto"
            >
              <v-text-field
                dense
                outlined
                type="number"
                min="1"
                style="width: 30px; margin-top: -14px"
                class="me-4 pt-0"
                hide-details
                v-model="data.item.time"
              >
              </v-text-field>
              <div style="margin-top: -3px">روز</div>
            </div>
          </template>
          <template v-slot:cell(percentage)="data">
            <div
              style="text-align: center; vertical-align: middle; width: 150px"
              class="d-flex flex-row mx-auto"
            >
              <v-text-field
                dense
                outlined
                type="number"
                min="1"
                style="width: 30px; margin-top: -14px"
                class="me-4 pt-0"
                hide-details
                v-model="data.item.percentage"
              >
              </v-text-field>
              <div style="margin-top: -3px">درصد</div>
            </div>
          </template>
          <template v-slot:cell(operation)="data">
            <div
              style="text-align: center; vertical-align: middle"
              class="pt-0"
            >
              <v-btn
                class="orange-mainBtn"
                width="120"
                :loading="loading3"
                @click="editFastBuy(data.item)"
                >اعمال تغییرات
                <v-icon class="ms-2" style="margin-top: -6px"
                  >$Edit</v-icon
                ></v-btn
              >
            </div>
          </template>
        </b-table>
      </div>
    </v-card>
  </div>
</template>

<script>
import Axios from "axios";
import Var from "../../../variables";
import moment from "moment-jalaali";
import { AtomSpinner } from "epic-spinners";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import MyCalendar from "../../components/MyCalendar.vue";

export default {
  components: {
    AtomSpinner,
    MyCalendar,
    datePicker: VuePersianDatetimePicker,
  },
  data() {
    return {
      creditTiers: [],
      tab: null,
      rules: {
        validPercentage: (value) => Number(value) < 100 || "",
      },
      reactivity: false,
      moment: moment,
      allExchanges: [],
      filter: "",
      guide: false,
      currentPage: 1,
      perPage: 10,
      perPageOptions: [4, 10, 20],
      options: [],
      saleTierOptions: [],
      creditExpiryDate: [],
      fastBuy: [],
      loading: [false, false, false, false],
      loading2: false,
      loading3: false,
      busy: false,
      startDate: "",
      endDate: "",
      type: Var.allTypes[3],
      expirationTimes: [
        {
          specialDuration: 6,
          duration: 1,
        },
      ],
      optionsFields: [
        // { key: "index", label: "ردیف" },
        { key: "name", label: "سطح‌بندی مشتری" },
        { key: "tierMinimumPrice", label: "حداقل میزان خرید برای ورود به سطح" },

        { key: "tierPercentage", label: "درصد دریافت اعتبار" },
        { key: "operation", label: "عملیات" },
      ],
      optionsFields2: [
        // { key: "index", label: "ردیف" },
        { key: "name", label: "سطح‌بندی فروش" },
        { key: "tierMinimumPrice", label: "حداقل میزان فروش سطح" },
        {
          key: "salePercentage",
          label: "درصد کمیسیون",
        },
        { key: "operation", label: "عملیات" },
      ],
      timesFields: [
        // { key: "index", label: "ردیف" },
        // { key: "vipCreditPeriod", label: "طول مدت امتیاز ویژه وفاداری" },
        { key: "time", label: "زمان انقضای اعتبار" },
        { key: "operation", label: "عملیات" },
      ],
      fastFields: [
        { key: "time", label: "بازه زمانی خرید سریع" },
        { key: "percentage", label: " درصد افزایش اعتبار برای یک خرید سریع" },
        { key: "operation", label: "عملیات" },
      ],
      oldObject: [],
      isBeforeChecked: false,
    };
  },
  methods: {
    toggleHelp() {
      this.guide = !this.guide;
    },
    getOptions() {
      this.busy = true;
      Axios.get(this.baseUrl + "/satrapp/option/getOptions", {
        headers: {
          Authorization: "Bearer: " + localStorage.getItem("shopToken"),
        },
      })
        .then((res) => {
          if (res.status == 200) {
            this.busy = false;
            this.options = res.data;
            this.creditTiers = this.options.creditTiers;
            this.saleTierOptions = this.options.saleTiers;
            this.fastBuy = this.options.fastBuy;
            this.creditExpiryDate = this.options.creditExpiryDate;
            this.oldObject = JSON.parse(
              JSON.stringify(this.options.creditTiers)
            );
            // this.options = [];
            // let options = res.data;
            // for (let prop in options) {
            //   if (
            //     prop != "creditExpiryDate" &&
            //     prop != "tehranShippingCost" &&
            //     prop != "freeShippingCost" &&
            //     prop != "nonTehranShippingCost" &&
            //     prop != "creditDiscountTime" &&
            //     prop != "fastBuy" &&
            //     prop != "creditExpiryDate" &&
            //     !prop.includes("saleTier")
            //   ) {
            //     this.options.push(options[prop] ? options[prop] : "");
            //     this.oldObject = JSON.parse(JSON.stringify(this.options));
            //   }
            //   if (prop.includes("saleTier")) {
            //     this.saleTierOptions.push(options[prop] ? options[prop] : "");
            //   }
            // }
            // this.times.push(res.data.creditExpiryDate);
            // this.fastBuy.push(res.data.fastBuy);
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );

            this.toast(title, "error");
            this.busy = false;
          }
        })
        .catch((err) => {
          console.log(err);
          this.toast("خطا: " + err.response.data, "error");
          this.busy = false;
        });
    },
    editCredit(item, index) {
      console.log(item);
      this.loading[index] = true;
      Axios.post(
        this.baseUrl + "/satrapp/option/newOption",
        {
          key: item.enName,
          value: {
            name: item.name,
            enName: item.enName,
            tierPercentage: Number(item.tierPercentage),
            tierMinimumPrice: Number(item.tierMinimumPrice),
          },
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("shopToken"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.toast(res.data, "success");
            this.loading[index] = false;
            this.getOptions();
            this.reactivity = !this.reactivity;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
            this.loading[index] = false;
            this.reactivity = !this.reactivity;
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
          this.loading[index] = false;
          this.reactivity = !this.reactivity;
        });
    },
    editSaleTier(item, index) {
      this.loading[index] = true;
      this.reactivity = !this.reactivity;
      Axios.post(
        this.baseUrl + "/satrapp/option/newOption",
        {
          key: item.enName,
          value: {
            name: item.name,
            enName: item.enName,
            salePercentage: Number(item.salePercentage),
            tierMinimumPrice: Number(item.tierMinimumPrice),
          },
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("shopToken"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.toast(res.data, "success");
            this.loading[index] = false;
            this.getOptions();
            this.reactivity = !this.reactivity;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
            this.loading[index] = false;
            this.reactivity = !this.reactivity;
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
          this.loading[index] = false;
          this.reactivity = !this.reactivity;
        });
    },
    editFastBuy(item) {
      this.loading3 = true;
      Axios.post(
        this.baseUrl + "/satrapp/option/newOption",
        {
          key: "fastBuy",
          value: item,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("shopToken"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.toast(res.data, "success");
            this.loading3 = false;
            this.getOptions();
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
            this.loading3 = false;
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
          this.loading3 = false;
        });
    },
    editTime(item) {
      this.loading2 = true;
      Axios.post(
        this.baseUrl + "/satrapp/option/newOption",
        {
          key: "creditExpiryDate",
          value: item,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("shopToken"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.toast(res.data, "success");
            this.loading2 = false;
            this.getOptions();
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
            this.loading2 = false;
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
          this.loading2 = false;
        });
    },
    computedValidAmount(value, index) {
      if (index != 0 && value) {
        if (
          value > this.options.creditTiers[Number(index) - 1].tierMinimumPrice
        ) {
          return true;
        } else return false;
      } else return true;
    },
    computedFocusedField(item) {
      let result;
      if (
        JSON.stringify(this.options.creditTiers) ==
        JSON.stringify(this.oldObject)
      ) {
        result = true;
      } else if (
        JSON.stringify(
          this.options.creditTiers.filter((x) => x.enName == item.enName)
        ) !=
        JSON.stringify(this.oldObject.filter((x) => x.enName == item.enName))
      ) {
        result = true;
      } else {
        result = false;
      }
      this.isBeforeChecked = result;

      return result;
    },
    checkDisabledField(status) {
      if (!status) {
        this.toast("تغییرات اعمال شده را ابتدا ثبت کنید", "warning");
      }
    },
  },
  beforeRouteLeave(to, from, next) {
    if (!this.isBeforeChecked) {
      this.toast("تغییرات اعمال شده را ابتدا ثبت کنید", "warning");
    } else {
      next();
    }
  },
  mounted() {
    this.getOptions();
  },
};
</script>

<style lang="scss">
.options {
  .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded)
    > .v-input__control
    > .v-input__slot {
    background-color: #fff !important;
    border-radius: 8px !important;
  }
  .sort-box {
    border-radius: 10px;
    padding: 7px 15px;
    color: #656a81;

    &.selected-sort {
      background-color: #00b4d8;
      color: #fff;
      &:hover {
        background-color: #00b4d8;
      }
    }
    &:hover {
      background-color: #eee;
    }
  }
  .orange-borderedBtn {
    background-color: #f4f4ff !important;
  }
}

.credit-dialog-card {
  border-radius: 15px !important;
  padding: 10px;
  max-height: 680px;
  overflow-y: auto;
  .custom-input {
    .v-textarea {
      .v-input__slot {
        height: 246px !important;
      }
    }
    .v-input__slot {
      width: 100% !important;
    }
    .v-input__icon--append {
      padding-top: 3px !important;
      i {
        color: #ef6c00 !important;
        cursor: pointer;
      }
    }
  }
}
.inputPrice >>> input[type="number"] {
  -moz-appearance: textfield;
}
.inputPrice >>> input::-webkit-outer-spin-button,
.inputPrice >>> input::-webkit-inner-spin-button {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}
</style>
